
export default {
  name: 'BaseProfileAuthorLogoSelf',
  props: {
    author: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  computed: {
    imgSize() {
      switch (this.size) {
        case 'small':
          return 48
        case 'large':
          return 92

        default:
          return 92
      }
    },
    userName() {
      if (this.author.type === 'COMPANY') {
        return this.author.username
      } else {
        return this.author.profile?.firstName && this.author.profile?.lastName
          ? `${this.author.profile.firstName} ${this.author.profile.lastName}`
          : this.author.username
      }
    },
    imageRetinaUrl() {
      if (this.author.profile.avatar) {
        const [filename, extension] = this.author.profile.avatar
          .split('.')
          .reduce(
            (acc, val, i, arr) =>
              i === arr.length - 1
                ? [acc[0].substring(1), val]
                : [[acc[0], val].join('.')],
            []
          )
        return `${filename}x2.${extension}`
      }
      return null
    },
  },
}
